// @flow
import React, { Component } from 'react';
import {
  CardWrapperDiv,
  XIcon,
  EditLink,
  ActionWrapperDiv,
  SaveOutlineButton,
  ActionContainerDiv,
  ErrorText,
  SaveWrapperDiv
} from './CardStyles';
import { Desktop } from './Responsive';

type Props = {
  children?: React$Node,
  edit?: boolean,
  close?: boolean,
  save?: boolean,
  submitting?: boolean,
  error?: ?string,
  handleClose?: () => void,
  handleEdit?: () => void,
  handleSave?: () => void,
  className?: string,
  onClick?: () => void
};

export default class Card extends Component<Props> {
  render() {
    return (
      <CardWrapperDiv
        className={this.props.className}
        onClick={this.props.onClick}
      >
        <ActionContainerDiv>
          <ActionWrapperDiv>
            {this.props.save && (
              <Desktop>
                <SaveWrapperDiv>
                  <ErrorText>{this.props.error}</ErrorText>
                  <SaveOutlineButton
                    closeActive={this.props.close}
                    type="submit"
                    value="SAVE"
                    disabled={this.props.submitting}
                    onClick={this.props.handleSave}
                    small
                  >
                    SAVE
                  </SaveOutlineButton>
                </SaveWrapperDiv>
              </Desktop>
            )}

            {this.props.edit && (
              <EditLink
                closeActive={this.props.close}
                onClick={this.props.handleEdit}
              >
                Edit
              </EditLink>
            )}
            {this.props.close && (
              <XIcon name="x" onClick={this.props.handleClose} />
            )}
          </ActionWrapperDiv>
        </ActionContainerDiv>
        {this.props.children}
      </CardWrapperDiv>
    );
  }
}
